import { render, staticRenderFns } from "./DashedCard.vue?vue&type=template&id=fa345056"
import script from "./DashedCard.vue?vue&type=script&lang=js"
export * from "./DashedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports